import './Headline.scss';

import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@myome/ui';

import { CasrcadeLockup } from '@components/marketing/CasrcadeLockup/CasrcadeLockup';

interface HeadlineProps {
  description?: string;
  showCasrcadeLockup?: boolean;
  showStartButton?: boolean;
  title: string;
  onStart: () => void;
}

export const Headline = (props: HeadlineProps) => {
  const { description, onStart, showCasrcadeLockup = false, showStartButton = true, title } = props;

  return (
    <section className='headline-section'>
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            {showCasrcadeLockup && <CasrcadeLockup />}
            <h1 className={`headline-title${description ? ' headline-title--with-description' : ''}`}>{title}</h1>
            {description && <p className='headline-section__description'>{description}</p>}
            {showStartButton && (
              <div className='row'>
                <div className='col-12'>
                <Button onClick={onStart} variant='tertiary' endIcon={<FontAwesomeIcon icon={faArrowRight} />}>
                  Get Started
                </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
